<h1 class="text-center" [innerHTML]="'heizcheck.heizkostenabrechnung.start.headline' | translate"></h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-offset-1 medium-3 large-offset-2 large-3">
    <app-advisor-image path="/hec/verbrauchsanalyse-start.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-7 large-5">
    <p [innerHTML]="'heizcheck.heizkostenabrechnung.start.teaser' | translate"></p>
    <div class="callout lighter-gray bill show-for-large"><p [innerHTML]="'heizcheck.heizkostenabrechnung.start.callout2' | translate | safeHtml"></p></div>
  </div>
  <div class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8 ">
    <div class="callout lighter-gray bill hide-for-large"><p [innerHTML]="'heizcheck.heizkostenabrechnung.start.callout2' | translate | safeHtml"></p></div>
    <app-step-buttons previousLink="../../einstieg/heizungstyp" nextLink="../../heizkostenabrechnung/basisdaten/1" [nextSubmit]="false" mediumWidthRight="auto" mediumOffset="0" largeOffset="0" largeWidthRight="auto" nextText="heizcheck.heizkostenabrechnung.start.next"></app-step-buttons>
  </div>
</div>


<div class="grid-x grid-margin-x ki-hint">
  <div class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8">
    <div class="callout lighter-gray ki-selection-teaser" tabindex="0" role="button" [attr.aria-expanded]="showKiSelection" aria-controls="ki-selection" (keydown.enter)="toggleKiSelection()" [class.open]="showKiSelection" (click)="toggleKiSelection()">
      <img src="/gfx/hec/hector-move.gif" alt="">
      <p [innerHTML]="'heizcheck.heizkostenabrechnung.start.ki.intro' | translate"></p>
      <i class="icon-chevron-down"></i>
    </div>
  </div>
  @if (showKiSelection) {
    <div id="ki-selection" class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8 ki-selection-wrapper">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-6">
          <div class="callout lighter-gray upload">
            <p [innerHTML]="'heizcheck.heizkostenabrechnung.start.ki.upload' | translate"></p>
            <a routerLink="../../heizkostenabrechnung/start/upload" role="button" class="button primary hollow inline-arrow-right" [innerHTML]="'heizcheck.heizkostenabrechnung.start.ki.upload.button' | translate"></a>
          </div>
        </div>
        <div class="cell medium-6">
          <div class="callout lighter-gray foto">
            <p [innerHTML]="'heizcheck.heizkostenabrechnung.start.ki.foto' | translate"></p>
            <a routerLink="../../heizkostenabrechnung/start/foto" role="button" class="show-for-medium button primary hollow inline-arrow-right" [innerHTML]="'heizcheck.heizkostenabrechnung.start.ki.foto.button' | translate"></a>
            <a routerLink="../../foto" role="button" class="hide-for-medium button primary hollow inline-arrow-right" [innerHTML]="'heizcheck.heizkostenabrechnung.start.ki.device.button' | translate"></a>
          </div>
        </div>
      </div>
    </div>
  }
</div>
